var _path, _path2, _path3, _path4, _path5, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 18.125H20.625V25H27.5V18.125Z",
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 18.125H12.5V25H19.375V18.125Z",
    fill: "#E1E1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 10H20.625V16.875H27.5V10Z",
    fill: "#E1E1E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 10H12.5V16.875H19.375V10Z",
    fill: "#E1E1E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.25 7.5H3.75V27.5H36.25V7.5ZM3.75 5C2.36929 5 1.25 6.11929 1.25 7.5V27.5C1.25 28.8807 2.36929 30 3.75 30H36.25C37.6307 30 38.75 28.8807 38.75 27.5V7.5C38.75 6.11929 37.6307 5 36.25 5H3.75Z",
    fill: "#E1E1E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 32.5,
    width: 40,
    height: 2.5,
    rx: 1.25,
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopWindows);
export default __webpack_public_path__ + "static/media/laptop_windows.dabb56d7ffdd9c24b5a3d6f13f3fd6e9.svg";
export { ForwardRef as ReactComponent };